export enum BeneficialOwnership1071Status {
	NotStarted = 'notStarted',
	InProgress = 'inProgress',
	Completed = 'completed',
	NotApplicable = 'notApplicable',
}

export interface BeneficialOwnership1071StatusByCustomerId {
	[customerId: number]: BeneficialOwnership1071Status;
}